import { Routes } from '@angular/router';
import { authGuard, AccessRole } from 'lib-base';
import { hasPermisoGuard } from './shared/guards/has-permiso.guard';
import { LoginComponent } from './pages/public/login/login.component';
import EditFormComponent from './pages/formulario/edit-form/edit-form.component';
import { LandingComponent } from './pages/configuracion/landing/landing.component';
import { AdminUsuariosComponent } from './pages/seguridad/admin-usuarios/admin-usuarios.component';
import { AdminCargosComponent } from './pages/seguridad/admin-cargos/admin-cargos.component';
import { FormulariosComponent } from './pages/formulario/formularios/formularios.component';
import { AdminTramitesComponent } from './pages/configuracion/admin-tramites/admin-tramites.component';
import { ViewFormularioRespuestaComponent } from './pages/formulario/view-formulario-respuesta/view-formulario-respuesta.component';
import { AdminDependenciasComponent } from './pages/seguridad/admin-dependencias/admin-dependencias.component';
import { AdminActividadComponent } from './pages/configuracion/admin-actividad/admin-actividad.component';
import { TramiteWizardComponent } from './pages/configuracion/tramite-wizard/tramite-wizard.component';
import { PublicLayoutComponent } from './components/layouts/public-layout/public-layout.component';
import { AuthenticatedLayoutComponent } from './components/layouts/authenticated-layout/authenticated-layout.component';
import { HistoricoDeTramitesComponent } from './pages/dashboard/historico-de-tramites/historico-de-tramites.component';
import { DashboardGeneralComponent } from './pages/dashboard/dashboard-general/dashboard-general.component';
import { BalanceGeneralTramitePorDependenciaComponent } from './pages/dashboard/balance-general-tramite-por-dependencia/balance-general-tramite-por-dependencia.component';
import { TramitePorDependenciaComponent } from './pages/dashboard/tramite-por-dependencia/tramite-por-dependencia.component';
import { DetalleTramiteDependenciaComponent } from './pages/dashboard/detalle-tramite-dependencia/detalle-tramite-dependencia.component';
import { DetalleActividadesComponent } from './pages/dashboard/detalle-actividades/detalle-actividades.component';
import { ActivarUsuarioComponent } from './pages/public/activar-usuario/activar-usuario.component';
import { PasswordResetFormComponent } from './pages/public/password-reset-form/password-reset-form.component';
import { RestablecerPasswordComponent } from './pages/public/restablecer-password/restablecer-password.component';
import { GestionTramiteComponent } from './pages/configuracion/gestion-tramite/gestion-tramite.component';
import { isAuthenticatedGuard } from './guards/is-authenticated.guard';
import { AdminPQRSDComponent } from './pages/configuracion/admin-pqrsd/admin-pqrsd.component';
import { MisPQRSDComponent } from './pages/configuracion/mis-pqrsd/mis-pqrsd.component';
import { PqrsdActividadSeguimientoComponent } from './pages/configuracion/pqrsd-actividad-seguimiento/pqrsd-actividad-seguimiento.component';
import { GestionPQRSDComponent } from './pages/configuracion/gestion-pqrsd/gestion-pqrsd.component';
import { PortalUsuarioComponent } from './pages/seguridad/portal-usuario/portal-usuario.component';
import { DatasetsDinamicosComponent } from './pages/configuracion/datasets-dinamicos/datasets-dinamicos.component';
import { AsignacionManualComponent } from './pages/configuracion/asignacion-manual/asignacion-manual.component';
import { FirmaElectronicaRevocacionesComponent } from './pages/configuracion/firma-electronica-revocaciones/firma-electronica-revocaciones.component';
import { RevocacionSeguimientoComponent } from './pages/configuracion/firma-electronica-revocaciones/revocacion-seguimiento/revocacion-seguimiento.component';
import { ChatIaComponent } from "./pages/ia/chat-ia/chat-ia.component";
import { CorreoTemplateComponent } from "./components/correo-template/correo-template.component";
import { ControlTiempoComponent } from "./pages/configuracion/control-tiempo/control-tiempo.component";
import { ChatPqrsdComponent } from "./pages/ia/chat-pqrsd/chat-pqrsd.component";
import { ChatConsultasComponent } from './pages/ia/chat-consultas/chat-consultas.component';
import {
  DashboardGeneralSisbenComponent
} from "./pages/dashboard/dashboard-general-sisben/dashboard-general-sisben.component";
import {TramitesSisbenComponent} from "./pages/dashboard/tramites-sisben/tramites-sisben.component";
import { ConsultaSisbenComponent } from './pages/sisben/consulta/consulta-sisben.component';
import { PerfilSisbenComponent } from './pages/sisben/perfil/perfil-sisben.component';
import { SisbenGestionComponent } from './pages/sisben/sisben-gestion/sisben-gestion.component';
import { UikitComponent } from './pages/dashboard/uikit/uikit.component';

export const routes: Routes = [
  { path: '', redirectTo: 'public/login', pathMatch: 'full' },
  {
    path: 'public', component: PublicLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent, canActivate: [isAuthenticatedGuard()] },
      { path: 'activar-usuario/:codigo', component: ActivarUsuarioComponent },
      { path: 'restablecer-password/:codigo', component: RestablecerPasswordComponent },
      { path: 'solicitud-restablecer-password', component: PasswordResetFormComponent },
      { path: "**", redirectTo: "login" },
    ]
  },
  {
    path: 'configuracion', component: AuthenticatedLayoutComponent,
    canActivate: [authGuard()],
    canActivateChild: [authGuard()],
    children: [
      { path: 'chat-assistant', title: 'Asistente tramites', component: ChatIaComponent },
      { path: 'chat-assistant-pqrsdf', title: 'Asistente PQRSDF', component: ChatPqrsdComponent },
      { path: 'chat-consultas', title: 'Chat Consultas', component: ChatConsultasComponent , canActivate: [hasPermisoGuard(AccessRole.CHAT_CLIENT_DEV)] },
      { path: 'plantilla-correo', component: CorreoTemplateComponent },
      { path: 'control-tiempo', component: ControlTiempoComponent },
      { path: "landing", component: LandingComponent, canActivate: [hasPermisoGuard(AccessRole.GESTION_TRAMITE)] },
      { path: "gestion-tramites", component: GestionTramiteComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_TRAM)] },
      { path: "admin-tramites", component: AdminTramitesComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_TRAM)] },
      { path: "tramite-wizard", component: TramiteWizardComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_TRAM)] },
      { path: "actividad/:tramRegistroId/:actividadId", component: AdminActividadComponent, canActivate: [hasPermisoGuard([AccessRole.ADMIN_TRAM, AccessRole.GESTION_TRAMITE])] },
      { path: "admin-pqrsd", component: AdminPQRSDComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_PQRSD)] },
      { path: "gestion-pqrsd", component: GestionPQRSDComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_PQRSD)] },
      { path: "mis-pqrsd", component: MisPQRSDComponent, canActivate: [hasPermisoGuard(AccessRole.GESTION_PQRSD)] },
      { path: "pqrsd-actividad/:solicitudId/:actividadId", component: PqrsdActividadSeguimientoComponent, canActivate: [hasPermisoGuard([AccessRole.GESTION_PQRSD, AccessRole.ADMIN_PQRSD])] },
      { path: "datasets-dinamicos", component: DatasetsDinamicosComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_TRAM)] },
      { path: "asignacion-manual", component: AsignacionManualComponent, canActivate: [hasPermisoGuard(AccessRole.ASIGNACION_MANUAL)] },
      { path: "firma-electronica/revocaciones", component: FirmaElectronicaRevocacionesComponent, canActivate: [hasPermisoGuard(AccessRole.GESTION_FIRMA_ELECTRONICA)] },
      { path: "firma-electronica/revocaciones/seguimiento/:solicitudId", component: RevocacionSeguimientoComponent, canActivate: [hasPermisoGuard(AccessRole.GESTION_FIRMA_ELECTRONICA)] },
      {
        path: 'formulario', children: [
          { path: "formularios", title: "Formularios", component: FormulariosComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_FORM)] },
          { path: "edit", title: "New Form", component: EditFormComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_FORM)] },
          { path: 'edit/:formId', title: "Edit Form", component: EditFormComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_FORM)] },
          { path: 'edit/:formId/:version', title: "Edit Form", component: EditFormComponent, canActivate: [hasPermisoGuard(AccessRole.ADMIN_FORM)] },
          { path: "view-respuesta/:tramRegistroId", component: ViewFormularioRespuestaComponent, canActivate: [hasPermisoGuard([AccessRole.ADMIN_TRAM, AccessRole.GESTION_TRAMITE])] },
          { path: "**", redirectTo: "formularios" },
        ]
      },
      { path: "**", redirectTo: "landing" },
    ]
  },
  {
    path: 'seguridad', component: AuthenticatedLayoutComponent, title: 'Seguridad',
    canActivate: [authGuard(), hasPermisoGuard(AccessRole.ADMIN_SEC)],
    canActivateChild: [authGuard(), hasPermisoGuard(AccessRole.ADMIN_SEC)],
    children: [
      { path: "admin-usuario", component: AdminUsuariosComponent },
      { path: "admin-cargos", component: AdminCargosComponent },
      { path: "admin-dependencias", component: AdminDependenciasComponent },
      { path: "portal-usuario", component: PortalUsuarioComponent },
      { path: "**", redirectTo: "/configuracion/landing" },
    ]
  },
  {
    path: 'dashboard', component: AuthenticatedLayoutComponent,
    canActivate: [authGuard(), hasPermisoGuard(AccessRole.ADMIN_DASHBOARD)],
    canActivateChild: [authGuard(), hasPermisoGuard(AccessRole.ADMIN_DASHBOARD)],
    children: [
      { path: "historico-tramites", component: HistoricoDeTramitesComponent, title: 'Historico de trámites' },
      { path: "general", component: DashboardGeneralComponent, title: 'Dashboard general' },
			{ path: "general-sisben", component: DashboardGeneralSisbenComponent },
      { path: "balance-tramites-por-dependencia", component: BalanceGeneralTramitePorDependenciaComponent },
      { path: "tramites-por-dependencia", component: TramitePorDependenciaComponent },
			{ path: "tramites-sisben", component: TramitesSisbenComponent },
      { path: "detalle-tramite-dependencia/:dependenciaId/:dependenciaNombre", component: DetalleTramiteDependenciaComponent },
      { path: "detalle-actividades/:tipoTramiteId/:dependenciaId/:secUsuarioId", component: DetalleActividadesComponent },
      { path: "uikit", component: UikitComponent }
    ]
  },
  {
    path: 'sisben', component: AuthenticatedLayoutComponent,
    canActivate: [authGuard(), hasPermisoGuard(AccessRole.SISBEN)],
    canActivateChild: [authGuard(), hasPermisoGuard(AccessRole.SISBEN)],
    children: [
      { path: "gestion", component: SisbenGestionComponent, title: 'Gestión SISBEN' },
      { path: "consulta", component: ConsultaSisbenComponent, title: 'Consulta SISBEN' },
      { path: "perfil/:sisbenId", component: PerfilSisbenComponent, title: 'Perfil' },
    ]
  }
];
